export default function AuthoritySection() {
  return (
    <section
      id="authority"
      className="relative overflow-hidden"
      style={{
        background: `
          repeating-linear-gradient(
            0deg,
            transparent,
            transparent 28px,
            rgba(180,160,120,0.06) 28px,
            rgba(180,160,120,0.06) 29px
          ),
          repeating-linear-gradient(
            90deg,
            transparent,
            transparent 28px,
            rgba(180,160,120,0.04) 28px,
            rgba(180,160,120,0.04) 29px
          ),
          linear-gradient(160deg, #FDFAF4 0%, #F7F2E8 40%, #F2EBD9 100%)
        `,
      }}
    >
      {/* ── Washi texture overlay ── */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='300'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='300' height='300' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E")`,
          backgroundSize: '300px 300px',
          opacity: 0.6,
        }}
      />

      {/* ════════════════════════════
          ①  SECTION HEADER
      ════════════════════════════ */}
      <div className="relative z-10 pt-28 pb-12 text-center px-6">
        <p
          className="text-sm tracking-[0.35em] text-[#8B6914] mb-5 uppercase"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          KAITORIKAWASEMI — About the Appraiser
        </p>
        <h2
          className="text-5xl md:text-6xl font-bold text-[#1B3A2D] leading-snug mb-6"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          吉田が、直接伺います。
        </h2>
        <div className="flex items-center justify-center gap-4 mb-7">
          <div className="h-px w-24 bg-gradient-to-r from-transparent to-[#C9A84C]" />
          <div className="w-2 h-2 rounded-full bg-[#C9A84C]" />
          <div className="h-px w-24 bg-gradient-to-l from-transparent to-[#C9A84C]" />
        </div>
        <p
          className="text-lg text-[#4A3728] max-w-2xl mx-auto leading-loose"
          style={{ fontFamily: "'Noto Serif JP', serif" }}
        >
          遺品整理・生前整理にあたり、大切なお品を手放す決断をされた方へ。<br />
          その重みを知るからこそ、私は誠実に向き合い続けます。
        </p>
      </div>

      {/* ════════════════════════════
          ②  YOSHIDA PHOTO + LICENSE
      ════════════════════════════ */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 pb-20">
        {/* Full-width photo */}
        <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-[#C9A84C]/30" style={{ height: '560px' }}>
          <img
            src="https://static.readdy.ai/image/aec91cb01fdf30f00658c017aec0d8c9/19e015cea55d3cc385047827e596632f.png"
            alt="鑑定士 吉田"
            className="w-full h-full object-cover object-top"
          />
          {/* Gradient fade at bottom for text */}
          <div className="absolute inset-0 bg-gradient-to-t from-[#1B3A2D]/80 via-[#1B3A2D]/10 to-transparent" />

          {/* Name overlay at bottom-left */}
          <div className="absolute bottom-8 left-8">
            <p
              className="text-white/70 text-sm tracking-widest mb-1"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              代表鑑定士
            </p>
            <p
              className="text-white text-4xl font-bold"
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              吉田 佑也
            </p>
          </div>
        </div>

        {/* Gold-framed License Nameplate — below the photo, not overlaying face */}
        <div className="mt-8 flex justify-center">
          <div
            className="relative px-10 py-7 rounded-xl border-2 border-[#C9A84C] shadow-lg"
            style={{
              background: 'linear-gradient(135deg, #FFFEF7 0%, #FBF5E0 50%, #F7EEC8 100%)',
            }}
          >
            {/* Corner ornaments */}
            <div className="absolute top-2 left-2 w-4 h-4 border-t-2 border-l-2 border-[#C9A84C]" />
            <div className="absolute top-2 right-2 w-4 h-4 border-t-2 border-r-2 border-[#C9A84C]" />
            <div className="absolute bottom-2 left-2 w-4 h-4 border-b-2 border-l-2 border-[#C9A84C]" />
            <div className="absolute bottom-2 right-2 w-4 h-4 border-b-2 border-r-2 border-[#C9A84C]" />

            <div className="text-center">
              <p
                className="text-[#8B6914] text-xs tracking-[0.3em] uppercase mb-2"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                神奈川県公安委員会認可
              </p>
              <div className="w-16 h-px bg-[#C9A84C] mx-auto mb-3" />
              <p
                className="text-[#1B3A2D] text-xl font-bold tracking-wide mb-1"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                古物商許可証
              </p>
              <p
                className="text-[#4A3728] text-base tracking-widest"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                第 451370014326 号
              </p>
              <div className="w-16 h-px bg-[#C9A84C] mx-auto mt-3" />
            </div>
          </div>
        </div>

        {/* ════════════════════════════
            ③  YOSHIDA'S NARRATIVE PROMISE
        ════════════════════════════ */}
        <div className="mt-16 max-w-3xl mx-auto">
          <h3
            className="text-3xl md:text-4xl font-bold text-[#1B3A2D] mb-8 text-center leading-snug"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            古物商歴10年、鑑定士 吉田の<br />
            <span className="text-[#8B6914]">『約束』</span>
          </h3>
          <div
            className="space-y-6 text-[#3D2B1F] text-lg leading-[2.2] text-justify"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            <p>
              この仕事を始めたころ、私はただの「買取業者」でした。
              しかし、10年間で数万点のお品と向き合う中で、気づいたことがあります。
              それは——<strong>品物の向こうには、必ず「人の人生」がある</strong>ということです。
            </p>
            <p>
              亡くなったお父様が大切にされていた時計。お母様が嫁入り道具として持参された着物。
              数十年前に子どもが贈ってくれたアクセサリー。
              私が鑑定台に置かれた一点の品を手に取るとき、その重さは金額だけでは測れません。
            </p>
            <p>
              ご遺族の方が「少しでも誰かの役に立てるなら」と仰って、涙をこらえながらお品を出してくださる瞬間があります。
              その場に立ち会うたびに、私は自分がただの「査定士」ではなく、
              <strong>「ご家族の想いをお預かりする者」である</strong>と、強く感じます。
            </p>
            <p>
              だから私は、値付けの前に必ず「この品にまつわるご事情」をお聞きします。
              急かしません。無理強いしません。納得いただけるまで、何度でも説明します。
              そしてお買取りさせていただいたお品には、次の持ち主が大切に扱ってくれるよう、
              私が責任を持って橋渡しをします。
            </p>
            <p className="text-[#1B3A2D] font-bold text-xl text-center pt-4">
              「大切に扱います。それが、私の約束です。」
            </p>
          </div>
        </div>
      </div>

      {/* ════════════════════════════
          ④  HISUIの約束 (COMPLIANCE)
      ════════════════════════════ */}
      <div
        className="relative z-10 py-20 px-6"
        style={{
          background: 'linear-gradient(135deg, #2D4A35 0%, #3A5C42 40%, #4A6B4F 100%)',
        }}
      >
        {/* subtle washi overlay on dark section */}
        <div
          className="absolute inset-0 pointer-events-none opacity-10"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.75' numOctaves='3'/%3E%3CfeColorMatrix type='saturate' values='0'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.08'/%3E%3C/svg%3E")`,
          }}
        />
        <div className="relative max-w-3xl mx-auto">
          <p
            className="text-[#C9A84C] text-xs tracking-[0.35em] uppercase text-center mb-3"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            Commitment &amp; Compliance
          </p>
          <h3
            className="text-3xl md:text-4xl font-bold text-white text-center mb-3 leading-snug"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            買い取りかわせみの約束
          </h3>
          <div className="flex items-center justify-center gap-4 mb-12">
            <div className="h-px w-20 bg-[#C9A84C]/60" />
            <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]" />
            <div className="h-px w-20 bg-[#C9A84C]/60" />
          </div>

          <div className="space-y-5">
            {/* Compliance item 1 */}
            <div
              className="flex items-start gap-5 rounded-xl px-7 py-6 border border-white/10"
              style={{ background: 'rgba(255,255,255,0.07)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-2xl text-[#C9A84C]" />
              </div>
              <div>
                <p
                  className="text-white font-bold text-lg mb-1"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  強引な押し買いの徹底禁止
                </p>
                <p
                  className="text-white/70 text-base leading-relaxed"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  「売らなくていい」と言える雰囲気を常に保ちます。査定後のお断りも、いつでも笑顔でお受けします。
                </p>
              </div>
            </div>

            {/* Compliance item 2 */}
            <div
              className="flex items-start gap-5 rounded-xl px-7 py-6 border border-white/10"
              style={{ background: 'rgba(255,255,255,0.07)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-time-line text-2xl text-[#C9A84C]" />
              </div>
              <div>
                <p
                  className="text-white font-bold text-lg mb-1"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  クーリングオフ完全対応
                </p>
                <p
                  className="text-white/70 text-base leading-relaxed"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  ご契約後も一定期間内であれば、無条件でキャンセルを承ります。法定期間を超えた対応も、可能な限り誠実に行います。
                </p>
              </div>
            </div>

            {/* Compliance item 3 */}
            <div
              className="flex items-start gap-5 rounded-xl px-7 py-6 border border-white/10"
              style={{ background: 'rgba(255,255,255,0.07)' }}
            >
              <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-id-card-line text-2xl text-[#C9A84C]" />
              </div>
              <div>
                <p
                  className="text-white font-bold text-lg mb-1"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  古物営業法に基づく本人確認の実施
                </p>
                <p
                  className="text-white/70 text-base leading-relaxed"
                  style={{ fontFamily: "'Noto Serif JP', serif" }}
                >
                  法令に従い、正確な本人確認を実施します。これはお客様を守るためでもあり、安心して取引いただくための大切な手続きです。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ════════════════════════════
          ⑤  確かな実績 (METRICS)
      ════════════════════════════ */}
      <div
        className="relative z-10 py-20 px-6"
        style={{
          background: 'linear-gradient(160deg, #F7F2E6 0%, #EDE4CE 100%)',
        }}
      >
        <div className="relative max-w-4xl mx-auto">
          <p
            className="text-[#8B6914] text-xs tracking-[0.35em] uppercase text-center mb-3"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            Track Record
          </p>
          <h3
            className="text-3xl md:text-4xl font-bold text-[#1B3A2D] text-center mb-3"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            確かな実績
          </h3>
          <div className="flex items-center justify-center gap-4 mb-14">
            <div className="h-px w-20 bg-[#C9A84C]/60" />
            <div className="w-1.5 h-1.5 rounded-full bg-[#C9A84C]" />
            <div className="h-px w-20 bg-[#C9A84C]/60" />
          </div>

          {/* Three-column metrics */}
          <div className="grid grid-cols-3 gap-0 items-end">
            {/* Left: 買取実績 */}
            <div className="text-center pb-6 border-r border-[#C9A84C]/30">
              <p
                className="text-[#8B6914] text-xs tracking-widest mb-4"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                買取実績
              </p>
              <p
                className="text-5xl font-bold text-[#1B3A2D] leading-none mb-2"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                1,000
              </p>
              <p
                className="text-[#4A3728] text-base"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                件以上
              </p>
            </div>

            {/* Center: 業界経験 10年 — LARGEST */}
            <div className="text-center pb-2 px-4">
              <p
                className="text-[#8B6914] text-xs tracking-widest mb-4"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                業界経験
              </p>
              <p
                className="font-bold text-[#1B3A2D] leading-none mb-1"
                style={{
                  fontFamily: "'Noto Serif JP', serif",
                  fontSize: '5.5rem',
                  lineHeight: 1,
                }}
              >
                10
              </p>
              <p
                className="text-[#4A3728] text-2xl font-semibold mb-2"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                年
              </p>
              <div className="w-16 h-0.5 bg-[#C9A84C] mx-auto mt-3 mb-3" />
              <p
                className="text-[#6B5334] text-sm leading-relaxed"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                数万点の品と向き合ってきた<br />経験と眼力
              </p>
            </div>

            {/* Right: ご紹介多数 満足度98% */}
            <div className="text-center pb-6 border-l border-[#C9A84C]/30">
              <p
                className="text-[#8B6914] text-xs tracking-widest mb-4"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                ご紹介多数
              </p>
              <p
                className="text-5xl font-bold text-[#1B3A2D] leading-none mb-2"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                98
                <span className="text-2xl">%</span>
              </p>
              <p
                className="text-[#4A3728] text-base"
                style={{ fontFamily: "'Noto Serif JP', serif" }}
              >
                お客様満足度
              </p>
            </div>
          </div>

          {/* Bottom note */}
          <p
            className="text-center text-[#8B6914] text-sm mt-12 tracking-wide"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            ※ お客様アンケートおよびご紹介件数実績に基づく（2024年度）
          </p>
        </div>
      </div>
    </section>
  );
}
